import { z } from 'zod';
import { DefaultPackageForm } from '@pages/Default';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/connect/_authenticated/default/')({
  component: DefaultPackageForm,
  validateSearch: z.object({
    trackingId: z.string(),
  }),
});
